import { useState, useEffect } from "react";

const useWindowSize = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth <= 790);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth <= 790);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop;
};

export default useWindowSize;
